import { useLocation } from 'react-router-dom'

export function useIsArchiveMode() {
	const { pathname } = useLocation()
	return pathname.includes('archive')
}
